import { LenseAttribute, LenseConfig } from 'types/pricingSimulator';

export const getLenseConfigParser = (data: any) => {
    try {
        const results: Array<LenseConfig> = [];

        if (data?.lens_kpis) {
            data?.lens_kpis?.forEach((item: any) => {
                const attributes: Array<LenseAttribute> = item?.kpis.map((i: any) => {
                    return {
                        isSelected: i.ticked,
                        name: i.kpi_name,
                        attributeId: i.kpi_id,
                        isEditable: i?.editable,
                        pre: i?.pre,
                        post: i?.post,
                        iconType: i?.icon_type_id,
                        kpiTypeId: i?.kpi_type_id,
                        availableForBulkUpload: i.available_for_bulk_upload,
                        kpiKeyName: i.kpi_key_name,
                        allowIncrementChange: i.allow_increment_change,
                        allowAbsChange: i.allow_abs_change,
                        allowFinalValueChange: i.allow_final_value_change,
                        allowedDecimals: i.allowed_decimals,
                        hasKpiRulesValidations: i.has_kpi_rules_validations,
                        allowNegative: i.allow_negative,
                    };
                });
                const isAllSelected = attributes?.every((l: LenseAttribute) => l?.isSelected);
                const isSelected = attributes?.some((l: LenseAttribute) => l?.isSelected);

                results.push({
                    isAllSelected,
                    isSelected,
                    lenseName: item.lens_name,
                    lenseId: item.lens_id,
                    attributes: attributes,
                });
            });
            return results;
        }
    } catch (error) {
        throw error;
    }
};

//for analytics page
export const getLenseConfigAnalyticsParser = (data: any) => {
    try {
        const results: Array<LenseConfig> = [];
        if (data?.lens_kpis) {
            data?.lens_kpis?.forEach((item: any) => {
                const attributes: Array<LenseAttribute> = item?.kpis.map((i: any) => {
                    return {
                        isSelected: false,
                        name: i.kpi_name,
                        attributeId: i.kpi_id,
                        isEditable: i?.editable,
                        pre: i?.pre,
                        post: i?.post,
                        kpiTypeId: i?.kpi_type_id,
                    };
                });

                results.push({
                    isAllSelected: false,
                    isSelected: false,
                    lenseName: item.lens_name,
                    lenseId: item.lens_id,
                    attributes: attributes,
                });
            });
            return results;
        }
    } catch (error) {
        throw error;
    }
};
